import React, { Component, Fragment } from 'react';
import BObjectId from 'bson-objectid';
import { withRouter, NavLink as RouterLink } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { DropdownButton, Dropdown, Form } from 'react-bootstrap';

import { PayPalButton } from 'react-paypal-button-v2';
import Checkout from '../../Checkout';

import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

import { FiCheck, FiLock } from 'react-icons/fi';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Table from 'react-bootstrap/Table';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { GiTicket, GiPriceTag } from 'react-icons/gi';
import axios from './axios';
import { Typeahead } from 'react-bootstrap-typeahead';
import cities from './canadian-city';
import ax from 'axios';
const styles = theme => ({
	root: {
		width: '100%',
	},
	backButton: {
		marginRight: theme.spacing(1),
	},
	instructions: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},
	btnBack: {
		background: 'transparent',
		'&:disabled': {
			background: 'transparent',
			cursor: 'pointer',
		},
	},
	CP: {
		padding: '0 2vh !important',
	},
	modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        
      },
      paper1: {
        borderRadius:'10px',
        backgroundColor:'white',   
        boxShadow: "black 0px 0px 20px 5px",
        width:'100vh',
        height:'20vh'
	  },
	  paperCareer: {
        borderRadius:'10px',
        boxShadow: "black 0px 0px 20px 5px",
        backgroundColor:'white',
        width:'100vh',
        height:'50vh'
      },
});

const House = ['1 Bedroom Apartment', '2 Bedroom Apartment', '3 Bedroom Apartment', '4 Bedroom Apartment', '5 Bedroom Apartment', '6 Bedroom Apartment'];
const HearAbout = ['Google Search', 'Google Search Ad', 'Better Business Bureau', 'Billboard Advertisement', 'UPAK', 'Yellow Pages', 'A Friend', "I'm a Returning Customer", 'Other (Please specify in the text below)'];

class ContactThree extends Component {
	constructor(props) {
		super(props);
		this.state = {
			clientId: '',
			finalCost: 0,
			costWthTenPercentOff: 300,
			costWthTwentyFivePercentOff: 0,
			activeStep: 0,
			weight: 0,
			volume: 0,
			cityFrom: true,
			cityTo: true,
			errorMsg: '',
			streetFrom: false,
			streetFromMsg: '',
			streetToMsg: '',
			streetTo: false,
			depositeNowPrice: 0,
			OpenModal: false,
			steps: ['Client Information', 'Moving Details', 'Other Details', 'Items to Move', 'Estimate', 'Reserve you next move'],
			disabled: true,
			allCities: [],
			allProvince: [],
			clientInfo: {
				firstName: '',
				email: '',
				phoneNo: '',
				lastName: '',
				prefferedMovingDate: '',
				prefferedMovingTime: '',
			},

			movingFromDetails: {
				street: '',
				unitNumber: '',
				city: '',
				state: '',
				zip: '',
				hasElevator: '',
				flightOfStairs: '',
			},
			movingToDetails: {
				street: '',
				unitNumber: '',
				city: '',
				state: '',
				zip: '',
				hasElevator: '',
				flightOfStairs: '',
			},
			otherDetails: {
				sizeOfCurrentHome: 'Size of your current home',
				packingServiceRequired: '',
				storageRequired: '',
				hearedAboutUs: 'How did you hear about us',
				note: '',
				storageMonths: '',
			},
			paymentInfo: {
				address1: '',
				address2: '',
				city: '',
				country: '',
				card: '',
				state: '',
				zip: '',
				expiryDate: '',
				cvv: '',
			},
			listOfItems: {
				Bed_Rooms: {
					categoryId: '',
					items: [
						{ itemId: '1', isSelected: false, item: 'ARMOIRE', CuFt: 40, quantity: '' },
						{ itemId: '2', isSelected: false, item: 'BED, SINGLE', CuFt: 40, quantity: '' },
						{ itemId: '3', isSelected: false, item: 'BED, DOUBLE', CuFt: 60, quantity: '' },
						{ itemId: '4', isSelected: false, item: 'BED, BUNK (SET OF 2)', CuFt: 70, quantity: '' },
						{ itemId: '5', isSelected: false, item: 'BED, QUEEN SIZE	', CuFt: 70, quantity: '' },
						{ itemId: '6', isSelected: false, item: 'BED, KING SIZE', CuFt: 80, quantity: '' },
						{ itemId: '7', isSelected: false, item: 'CHAIR', CuFt: 10, quantity: '' },
						{ itemId: '8', isSelected: false, item: 'STRAIGHT OR ROCKER', CuFt: 5, quantity: '' },
						{ itemId: '9', isSelected: false, item: 'CHAISE LOUNGE', CuFt: 25, quantity: '' },
						{ itemId: '10', isSelected: false, item: 'CHEST OF DRAWERS SM', CuFt: 20, quantity: '' },
						{ itemId: '11', isSelected: false, item: 'CHEST OF DRAWERS LG', CuFt: 30, quantity: '' },
						{ itemId: '12', isSelected: false, item: 'DRESSER, SINGLE', CuFt: 30, quantity: '' },
						{ itemId: '13', isSelected: false, item: 'DRESSER, DOUBLE', CuFt: 40, quantity: '' },
						{ itemId: '14', isSelected: false, item: 'DRESSER, TRIPLE', CuFt: 50, quantity: '' },
						{ itemId: '15', isSelected: false, item: 'NIGHT TABLE', CuFt: 5, quantity: '' },
						{ itemId: '16', isSelected: false, item: 'RUG, SMALL', CuFt: 3, quantity: '' },
						{ itemId: '17', isSelected: false, item: 'RUG, LARGE', CuFt: 10, quantity: '' },
						{ itemId: '18', isSelected: false, item: 'VANITY & BENCH', CuFt: 5, quantity: '' },
					],
				},
				Dining_Room: {
					categoryId: '',
					items: [
						{ itemId: '1', isSelected: false, item: 'DINING CHAIR', CuFt: 5, quantity: '' },
						{ itemId: '2', isSelected: false, item: 'BUFFET ( BASE )', CuFt: 30, quantity: '' },
						{ itemId: '3', isSelected: false, item: 'HUTCH ( TOP )', CuFt: 20, quantity: '' },
						{ itemId: '4', isSelected: false, item: 'SERVER / SIDEBOARD', CuFt: 15, quantity: '' },
						{ itemId: '5', isSelected: false, item: 'TABLE, EXTENSION', CuFt: 30, quantity: '' },
						{ itemId: '6', isSelected: false, item: 'TEA CART', CuFt: 10, quantity: '' },
						{ itemId: '7', isSelected: false, item: 'RUG, SMALL', CuFt: 3, quantity: '' },
						{ itemId: '8', isSelected: false, item: 'RUG, LARGE', CuFt: 10, quantity: '' },
					],
				},
				Miscellaneous: {
					categoryId: '',
					items: [
						{ itemId: '1', isSelected: false, item: 'BICYCLE', CuFt: 10, quantity: '' },
						{ itemId: '2', isSelected: false, item: 'BIRD CAGE & STAND', CuFt: 5, quantity: '' },
						{ itemId: '3', isSelected: false, item: 'CABINET FILING, 2 DRWR', CuFt: 10, quantity: '' },
						{ itemId: '4', isSelected: false, item: 'CABINET FILING, 4 DRWR', CuFt: 20, quantity: '' },
						{ itemId: '5', isSelected: false, item: 'CLOTHES HAMPER/BASKET', CuFt: 5, quantity: '' },
						{ itemId: '6', isSelected: false, item: 'COMPUTER SYSTEM', CuFt: 8, quantity: '' },
						{ itemId: '7', isSelected: false, item: 'FAN', CuFt: 5, quantity: '' },
						{ itemId: '8', isSelected: false, item: 'FOLDING CHAIR', CuFt: 2, quantity: '' },
						{ itemId: '9', isSelected: false, item: 'FOOT LOCKER', CuFt: 5, quantity: '' },
						{ itemId: '10', isSelected: false, item: 'GARBAGE CAN', CuFt: 5, quantity: '' },
						{ itemId: '11', isSelected: false, item: 'GOLF BAG', CuFt: 5, quantity: '' },
						{ itemId: '12', isSelected: false, item: 'HEATER, GAS OR ELEC', CuFt: 5, quantity: '' },
						{ itemId: '13', isSelected: false, item: 'OFFICE CHAIR', CuFt: 6, quantity: '' },
						{ itemId: '14', isSelected: false, item: 'PING PONG TABLE', CuFt: 10, quantity: '' },
						{ itemId: '15', isSelected: false, item: 'ROLLAWAY COT', CuFt: 5, quantity: '' },
						{ itemId: '16', isSelected: false, item: 'SKIS, POLES/SNOWBOARD', CuFt: 5, quantity: '' },
						{ itemId: '17', isSelected: false, item: 'STEP LADDER', CuFt: 5, quantity: '' },
						{ itemId: '18', isSelected: false, item: 'SUITCASE', CuFt: 5, quantity: '' },
						{ itemId: '19', isSelected: false, item: 'TIRE', CuFt: 5, quantity: '' },
						{ itemId: '20', isSelected: false, item: 'TOOL CHEST', CuFt: 7, quantity: '' },
						{ itemId: '21', isSelected: false, item: 'TRUNK', CuFt: 5, quantity: '' },
						{ itemId: '22', isSelected: false, item: "WAGON, CHILD'S", CuFt: 5, quantity: '' },
						{ itemId: '23', isSelected: false, item: 'WATER COOLER', CuFt: 8, quantity: '' },
						{ itemId: '24', isSelected: false, item: 'WEIGHTS', CuFt: 10, quantity: '' },
						{ itemId: '25', isSelected: false, item: 'WEIGHT BENCH', CuFt: 15, quantity: '' },
						{ itemId: '26', isSelected: false, item: 'WHEEL BARROW', CuFt: 8, quantity: '' },
						{ itemId: '27', isSelected: false, item: 'WORK BENCH', CuFt: 20, quantity: '' },
					],
				},
				Living_Room: {
					categoryId: '',
					items: [
						{ itemId: '1', isSelected: false, item: 'BENCH, PIANO', CuFt: 5, quantity: '' },
						{ itemId: '2', isSelected: false, item: 'BOOKCASE', CuFt: 20, quantity: '' },
						{ itemId: '3', isSelected: false, item: 'BOOKSHELVES, SECT.', CuFt: 5, quantity: '' },
						{ itemId: '4', isSelected: false, item: 'CHAIR, ARM', CuFt: 10, quantity: '' },
						{ itemId: '5', isSelected: false, item: 'CHAIR, OCCASIONAL', CuFt: 15, quantity: '' },
						{ itemId: '6', isSelected: false, item: 'CHAIR, OVERSIZED', CuFt: 25, quantity: '' },
						{ itemId: '7', isSelected: false, item: 'CHAIR, RECLINER', CuFt: 20, quantity: '' },
						{ itemId: '8', isSelected: false, item: 'CHAIR, ROCKING', CuFt: 7, quantity: '' },
						{ itemId: '9', isSelected: false, item: 'CHAIR, STRAIGHT', CuFt: 12, quantity: '' },
						{ itemId: '10', isSelected: false, item: 'SOFA, LOVESEAT', CuFt: 35, quantity: '' },
						{ itemId: '11', isSelected: false, item: 'SOFA', CuFt: 3, quantity: '' },
						{ itemId: '12', isSelected: false, item: 'CUSHION', CuFt: 50, quantity: '' },
						{ itemId: '13', isSelected: false, item: 'SOFA, HIDE A BED', CuFt: 40, quantity: '' },
						{ itemId: '14', isSelected: false, item: 'DESK', CuFt: 20, quantity: '' },
						{ itemId: '15', isSelected: false, item: 'FIREPLACE TOOLS', CuFt: 5, quantity: '' },
						{ itemId: '16', isSelected: false, item: 'FOOTSTOOL', CuFt: 2, quantity: '' },
						{ itemId: '17', isSelected: false, item: 'FUTON', CuFt: 30, quantity: '' },
						{ itemId: '18', isSelected: false, item: 'LAMP, FLOOR / POLE', CuFt: 3, quantity: '' },
						{ itemId: '19', isSelected: false, item: 'MUSIC OR ENT. UNIT', CuFt: 10, quantity: '' },
						{ itemId: '20', isSelected: false, item: 'PIANO, APT. SIZE', CuFt: 60, quantity: '' },
						{ itemId: '21', isSelected: false, item: 'PIANO, BABY GR', CuFt: 70, quantity: '' },
						{ itemId: '22', isSelected: false, item: 'PIANO, UPRIGHT', CuFt: 70, quantity: '' },
						{ itemId: '23', isSelected: false, item: 'PIANO, PARLOUR GR', CuFt: 80, quantity: '' },
						{ itemId: '24', isSelected: false, item: 'RUG, SMALL', CuFt: 3, quantity: '' },
						{ itemId: '25', isSelected: false, item: 'RUG, LARGE', CuFt: 10, quantity: '' },
						{ itemId: '26', isSelected: false, item: 'STEREO COMPONENTS', CuFt: 20, quantity: '' },
						{ itemId: '27', isSelected: false, item: 'STEREO SPEAKER', CuFt: 5, quantity: '' },
						{ itemId: '28', isSelected: false, item: 'TABLE, COFFEE', CuFt: 10, quantity: '' },
						{ itemId: '29', isSelected: false, item: 'TABLE, END', CuFt: 5, quantity: '' },
						{ itemId: '30', isSelected: false, item: 'TELEPHONE STAND', CuFt: 2, quantity: '' },
						{ itemId: '31', isSelected: false, item: 'T.V. (CRT TUBE)', CuFt: 10, quantity: '' },
						{ itemId: '32', isSelected: false, item: 'T.V. 19"', CuFt: 5, quantity: '' },
						{ itemId: '33', isSelected: false, item: 'T.V. 32"', CuFt: 10, quantity: '' },
						{ itemId: '34', isSelected: false, item: 'T.V. FLAT SCREEN 50"', CuFt: 10, quantity: '' },
						{ itemId: '35', isSelected: false, item: 'T.V. FLAT SCREEN 60"', CuFt: 15, quantity: '' },
						{ itemId: '36', isSelected: false, item: 'T.V. STAND', CuFt: 5, quantity: '' },
					],
				},
				Kitchen: {
					categoryId: '',
					items: [
						{ itemId: '1', isSelected: false, item: 'BREAKFAST CHAIR', CuFt: 5, quantity: '' },
						{ itemId: '2', isSelected: false, item: 'BREAKFAST TABLE', CuFt: 10, quantity: '' },
						{ itemId: '3', isSelected: false, item: 'IRONING BOARD', CuFt: 2, quantity: '' },
						{ itemId: '4', isSelected: false, item: 'KITCHEN CABINET', CuFt: 30, quantity: '' },
						{ itemId: '5', isSelected: false, item: 'MICROWAVE STAND', CuFt: 7, quantity: '' },
						{ itemId: '6', isSelected: false, item: 'STOOL', CuFt: 3, quantity: '' },
						{ itemId: '7', isSelected: false, item: 'UTILITY CABINET', CuFt: 10, quantity: '' },
						{ itemId: '8', isSelected: false, item: 'UTILITY TABLE', CuFt: 5, quantity: '' },
					],
				},
				Cartons: {
					categoryId: '',
					items: [
						{ itemId: '1', isSelected: false, item: 'BOX 2 CU.FT', CuFt: 2, quantity: '' },
						{ itemId: '2', isSelected: false, item: 'BOX 4 CU.FT', CuFt: 4, quantity: '' },
						{ itemId: '3', isSelected: false, item: 'BOX 5 CU.FT', CuFt: 5, quantity: '' },
						{ itemId: '4', isSelected: false, item: 'BOX 6 CU.FT', CuFt: 6, quantity: '' },
						{ itemId: '5', isSelected: false, item: 'CHINA BARREL', CuFt: 5, quantity: '' },
						{ itemId: '6', isSelected: false, item: 'LAMP SHADE', CuFt: 6, quantity: '' },
						{ itemId: '7', isSelected: false, item: 'MIRROR, SMALL', CuFt: 8, quantity: '' },
						{ itemId: '8', isSelected: false, item: 'MIRROR, LARGE', CuFt: 15, quantity: '' },
						{ itemId: '9', isSelected: false, item: 'WARDROBE', CuFt: 15, quantity: '' },
					],
				},
				Nursery: {
					categoryId: '',
					items: [
						{ itemId: '1', isSelected: false, item: 'BASSINET', CuFt: 5, quantity: '' },
						{ itemId: '2', isSelected: false, item: 'BED, YOUTH', CuFt: 30, quantity: '' },
						{ itemId: '3', isSelected: false, item: "CHAIR, CHILD'S", CuFt: 5, quantity: '' },
						{ itemId: '4', isSelected: false, item: 'CHAIR, HIGH', CuFt: 8, quantity: '' },
						{ itemId: '5', isSelected: false, item: 'CHEST OR DRESSER', CuFt: 12, quantity: '' },
						{ itemId: '6', isSelected: false, item: 'CRIB, BABY', CuFt: 10, quantity: '' },
						{ itemId: '7', isSelected: false, item: 'PLAY PEN', CuFt: 10, quantity: '' },
						{ itemId: '8', isSelected: false, item: 'RUG, SMALL', CuFt: 3, quantity: '' },
						{ itemId: '9', isSelected: false, item: 'RUG, LARGE', CuFt: 10, quantity: '' },
						{ itemId: '10', isSelected: false, item: 'STROLLER', CuFt: 5, quantity: '' },
						{ itemId: '11', isSelected: false, item: "TABLE, CHILD'S", CuFt: 5, quantity: '' },
					],
				},
				Appliances: {
					categoryId: '',
					items: [
						{ itemId: '1', isSelected: false, item: 'AIR CONDITIONER', CuFt: 10, quantity: '' },
						{ itemId: '2', isSelected: false, item: 'DEHUMIDIFIER', CuFt: 5, quantity: '' },
						{ itemId: '3', isSelected: false, item: 'DISHWASHER', CuFt: 20, quantity: '' },
						{ itemId: '4', isSelected: false, item: 'DRYER', CuFt: 25, quantity: '' },
						{ itemId: '5', isSelected: false, item: 'FREEZER, 10CU.FT OR LESS', CuFt: 30, quantity: '' },
						{ itemId: '6', isSelected: false, item: 'FREEZER, 11 -15 CU.FT', CuFt: 45, quantity: '' },
						{ itemId: '7', isSelected: false, item: 'FREEZER, 16 CU.FT & OVER', CuFt: 60, quantity: '' },
						{ itemId: '8', isSelected: false, item: 'MICROWAVE', CuFt: 6, quantity: '' },
						{ itemId: '9', isSelected: false, item: 'RANGE', CuFt: 30, quantity: '' },
						{ itemId: '10', isSelected: false, item: 'REFRIGERATOR, 6 CU.FT', CuFt: 30, quantity: '' },
						{ itemId: '11', isSelected: false, item: 'REFRIGERATOR, 7 - 10 CU.FT', CuFt: 45, quantity: '' },
						{ itemId: '12', isSelected: false, item: 'REFRIGERATOR, 11 CU.FT & OVER', CuFt: 60, quantity: '' },
						{ itemId: '13', isSelected: false, item: 'SEWING MACHINE/CABINET', CuFt: 15, quantity: '' },
						{ itemId: '14', isSelected: false, item: 'SEWING MACHINE PORTABLE', CuFt: 5, quantity: '' },
						{ itemId: '15', isSelected: false, item: 'SEWING MACHINE SERGER', CuFt: 5, quantity: '' },
						{ itemId: '16', isSelected: false, item: 'VACUUM CLEANER', CuFt: 5, quantity: '' },
						{ itemId: '17', isSelected: false, item: 'WASHING MACHINE', CuFt: 25, quantity: '' },
					],
				},
				Porch: {
					categoryId: '',
					items: [
						{ itemId: '1', isSelected: false, item: 'GARDEN HOSE, TOOLS', CuFt: 10, quantity: '' },
						{ itemId: '2', isSelected: false, item: 'LADDER, EXTENSION', CuFt: 20, quantity: '' },
						{ itemId: '3', isSelected: false, item: 'LAWN CHAIR', CuFt: 5, quantity: '' },
						{ itemId: '4', isSelected: false, item: 'LAWN CHAIR, STACKING', CuFt: 2, quantity: '' },
						{ itemId: '5', isSelected: false, item: 'LAWN MOWER, HAND', CuFt: 5, quantity: '' },
						{ itemId: '6', isSelected: false, item: 'LAWN MOVER, POWER', CuFt: 15, quantity: '' },
						{ itemId: '7', isSelected: false, item: "OUTDOOR CHILD'S SLIDE", CuFt: 10, quantity: '' },
						{ itemId: '8', isSelected: false, item: 'OUTDOOR DRYING RACK', CuFt: 5, quantity: '' },
						{ itemId: '9', isSelected: false, item: 'OUTDOOR SWING SET', CuFt: 30, quantity: '' },
						{ itemId: '10', isSelected: false, item: 'PICNIC BENCH', CuFt: 5, quantity: '' },
						{ itemId: '11', isSelected: false, item: 'PICNIC TABLE', CuFt: 20, quantity: '' },
						{ itemId: '12', isSelected: false, item: 'PORTABLE BBQ', CuFt: 15, quantity: '' },
						{ itemId: '13', isSelected: false, item: 'PORCH CHAIR', CuFt: 10, quantity: '' },
						{ itemId: '14', isSelected: false, item: 'ROCKER, SWING', CuFt: 15, quantity: '' },
						{ itemId: '15', isSelected: false, item: 'SANDBOX', CuFt: 10, quantity: '' },
						{ itemId: '16', isSelected: false, item: 'SETTEE', CuFt: 30, quantity: '' },
						{ itemId: '17', isSelected: false, item: 'TABLE', CuFt: 10, quantity: '' },
						{ itemId: '18', isSelected: false, item: 'UMBRELLA', CuFt: 5, quantity: '' },
					],
				},
				CartoForAnAverage: {
					categoryId: '',
					items: [
						{ itemId: '1', isSelected: false, item: 'BACHELOR', CuFt: 60, quantity: '' },
						{ itemId: '2', isSelected: false, item: '1 BEDROOM', CuFt: 80, quantity: '' },
						{ itemId: '3', isSelected: false, item: '1 BEDROOM + DEN', CuFt: 80, quantity: '' },
						{ itemId: '4', isSelected: false, item: '2 BEDROOM APT', CuFt: 125, quantity: '' },
						{ itemId: '5', isSelected: false, item: '2 BEDROOM HOUSE', CuFt: 150, quantity: '' },
						{ itemId: '6', isSelected: false, item: '3 BEDROOM', CuFt: 200, quantity: '' },
						{ itemId: '7', isSelected: false, item: '4 BEDROOM', CuFt: 300, quantity: '' },
					],
				},
			},
		};
	}

	handleOpen = () => {
		this.setState({ OpenModal: true });
	};
	handleClose = () => {
		this.setState({ OpenModal: false });
	};

	handleNext = async () => {
		let key = 'AIzaSyAe-RvE9UpwF-SNkKvlpt4YpjOgDfaUCpQ';
		
		if (this.state.activeStep === 1) {
			let address = this.state.movingFromDetails.city;
			let destination = this.state.movingToDetails.city;
			let url = `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${address} Canada&destinations=${destination} Canada&mode=driving&units=imperial&language=en&avoid=&key=${key}`;
			try {
			} catch (err) {
				console.log(err);
				this.setState({
					errorMsg: err.message,
				});
			}
			let checkAddresResult = await axios.get(url);
			console.log(checkAddresResult.data.rows[0].elements[0].status)
			if (checkAddresResult.data.rows[0].elements[0].status === 'NOT_FOUND') {
				
				this.setState({
					OpenModal : true,
					errorMsg:'No result found'

				});
				return 
			} else {

				this.setState({
					OpenModal : false,
					errorMsg : ''

				});
			}
			
		}

		this.setState(prevState => {
			return {
				activeStep: prevState.activeStep + 1,
			};
		});

		let address, destination;
		if (this.state.activeStep === 3) {
			for (let i in this.state.listOfItems) {
				try {
					console.log(this.state.listOfItems[i].categoryId);
					let categoryRes = await axios.post('/categories', { name: i });
					if (categoryRes.status === 201) {
						// console.log(categoryRes)
						let categoryId = categoryRes.data.Client._id;
						await this.setState(prevState => {
							return {
								listOfItems: { ...prevState.listOfItems, [i]: { ...prevState.listOfItems[i], categoryId: categoryId } },
							};
						});
						this.state.listOfItems[i].items.forEach(async item => {
							if (item.isSelected) {
								// console.log(item.quantity)

								let itemsDetails = {
									name: item.item,
									size: item.quantity,
									categoryId,
								};
								let itemRes = await axios.post('/items', itemsDetails);

								if (itemRes.status === 201) {
									await this.setState(prevState => {
										let updatedItems = prevState.listOfItems[i].items.map(items => {
											if (items.item === item.item) {
												// console.log(itemRes)
												return { ...items, itemId: itemRes.data.item._id };
											} else {
												return items;
											}
										});
										// console.log(updatedItems);
										// console.log(this.state[this.state.selectedCategory]);
										return {
											listOfItems: { ...prevState.listOfItems, [i]: { ...prevState.listOfItems[i], items: updatedItems } },
										};
									});
								}
								// console.log(this.state)
							}
						});
					}
				} catch (err) {
					console.log(err);
				}
			}

			try {
				if (this.state.movingFromDetails !== '' && this.state.movingToDetails !== '') {
					address = 'Toronto, ON, CA';
					destination = 'Vancouver, ON, CA';

					address = this.state.movingFromDetails.city;
					destination = this.state.movingToDetails.city;
				} else {
					return;
				}

				let url = `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${address}&destinations=${destination}&mode=driving&units=imperial&language=en&avoid=&key=${key}`;

				let listOfItems = [];
				listOfItems.push(this.state.listOfItems.Dining_Room);
				listOfItems.push(this.state.listOfItems.Bed_Rooms);
				listOfItems.push(this.state.listOfItems.Living_Room);
				listOfItems.push(this.state.listOfItems.Kitchen);
				listOfItems.push(this.state.listOfItems.Miscellaneous);
				listOfItems.push(this.state.listOfItems.Nursery);
				listOfItems.push(this.state.listOfItems.Porch);
				listOfItems.push(this.state.listOfItems.Porch);
				listOfItems.push(this.state.listOfItems.Cartons);
				listOfItems.push(this.state.listOfItems.Appliances);

				let movingFromDetails = { ...this.state.movingFromDetails, hasElevator: this.state.movingFromDetails.hasElevator === 'Yes' ? true : false };
				let movingToDetails = { ...this.state.movingToDetails, hasElevator: this.state.movingToDetails.hasElevator === 'Yes' ? true : false };
				let otherDetails = { ...this.state.otherDetails, packingServiceRequired: this.state.otherDetails.packingServiceRequired === 'Yes' ? true : false, storageRequired: this.state.otherDetails.storageRequired === 'Yes' ? true : false };
				const details = {
					clientInfo: this.state.clientInfo,
					movingFromDetails: movingFromDetails,
					movingToDetails: movingToDetails,
					listOfItems: listOfItems,
					otherDetails: otherDetails,
				};
				console.log(details);
				let itemsToMoves = await axios.post('/itemsToMove', details);
				if (itemsToMoves.status === 201) {
					let client_id = itemsToMoves.data.client._id;
					this.setState({
						clientId: client_id,
					});
				}
				let destinationTime = await axios.get(url);
				// console.log(destinationTime);
				if (destinationTime.data.status === 'OK') {
					let duration = destinationTime.data.rows[0].elements[0].duration;
					let T = duration.text.split(' ');
					console.log(T[1]);
					if (T[1] === 'day' || T[1] === 'days') {
						let t = T[4] !== null && T[4] > 30 ? 1 : 0;
						T = parseInt(T[0]) * 24 + parseInt(T[2]) + parseInt(t);
					} else if (T[1] === 'hours') {
						let t = T[1] !== null && T[2] > 30 ? 1 : 0;
						T = parseInt(T[0]) + parseInt(t);
					} else {
						let t = parseInt(T[1]) !== null && parseInt(T[1]) > 30 ? 1 : 0;
					}
					console.log(T);
					let wareFromHouse = '12841 59 Ave, Surrey, BC V3X 1T3, Canada';
					let urlFromWareHouse = `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${address}&destinations=${destination}&mode=driving&units=imperial&language=en&avoid=&key=${key}`;
					let wareHouseFromDestinaiton = await axios.get(urlFromWareHouse);
					let wTi = wareHouseFromDestinaiton.data.rows[0].elements[0].duration;
					let Ti = wTi.text.split(' ');
					if (Ti[1] === 'day' || T[1] === 'days') {
						let t = Ti[4] !== null && Ti[4] > 30 ? 1 : 0;
						Ti = parseInt(Ti[0]) * 24 + parseInt(Ti[2]) + parseInt(t);
					} else if (Ti[1] === 'hours') {
						let t = Ti[1] !== null && Ti[2] > 30 ? 1 : 0;
						Ti = parseInt(Ti[0]) + parseInt(t);
					} else {
						let t = parseInt(Ti[1]) !== null && parseInt(Ti[1]) > 30 ? 1 : 0;
					}
					Ti = 1;

					let wareToHouse = '12841 59 Ave, Surrey, BC V3X 1T3, Canada';
					let urlwareToHouse = `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${address}&destinations=${destination}&mode=driving&units=imperial&language=en&avoid=&key=${key}`;
					let wareHouseToDestinaiton = await axios.get(urlwareToHouse);
					let wTf = wareHouseToDestinaiton.data.rows[0].elements[0].duration;
					let Tf = wTf.text.split(' ');
					if (Tf[1] === 'day' || T[1] === 'days') {
						let t = Ti[4] !== null && Tf[4] > 30 ? 1 : 0;
						Tf = parseInt(Tf[0]) * 24 + parseInt(Tf[2]) + parseInt(t);
					} else if (Tf[1] === 'hours') {
						let t = Tf[1] !== null && Tf[2] > 30 ? 1 : 0;
						Tf = parseInt(Tf[0]) + parseInt(t);
					} else {
						let t = parseInt(Tf[1]) !== null && parseInt(Tf[1]) > 30 ? 1 : 0;
					}
					Tf = 1;

					let Ts = 0;
					let costPerHour = 0;
					switch (this.state.otherDetails.sizeOfCurrentHome) {
						case '1 Bedroom Apartment':
							// based on condition 3 - 4
							Ts = 4;
							costPerHour= 133;
							break;
						case '2 Bedroom Apartment':
							// based on condition 5 - 6
							Ts = 5;
							costPerHour= 133;
							break;
						case '3 Bedroom Apartment':
							// based on condition 7 - 8
							Ts = 8;
							costPerHour= 168;
							break;
						case '4 Bedroom Apartment':
							// based on condition 8 - 10
							Ts = 10;
							costPerHour= 168;
							break;
						case '5 Bedroom Apartment':
							// based on condition 10+
							Ts = 12;
							costPerHour= 168;
							break;
					}
					let tn = (T + Ti + Tf + Ts) * costPerHour;
					let gst = 5;
					let finalCost = parseInt(tn) + (parseInt(tn) / 100) * gst;
					console.log(finalCost.toFixed(2));
					this.setState({
						finalCost: finalCost,
						costWthTenPercentOff: finalCost - (finalCost / 100) * 10,
						depositeNowPrice: (finalCost / 100) * 25,
					});
				}
			} catch (err) {
				console.log(err);
			}
			console.log(this.state);
		}
	};

	handleBack = () => {
		this.setState(prevState => {
			return {
				activeStep: prevState.activeStep - 1,
			};
		});
	};

	handleReset = () => {
		this.setState({ activeStep: 0 });
	};
	sendClientHanlder = () => {
		this.props.history.push({ pathname: '/movedetails', state: { clientInfo: this.state } });
	};

	handleClientInfo = (name, value) => {
		this.setState(prevState => {
			return {
				clientInfo: { ...prevState.clientInfo, [name]: value },
			};
		});

		for (let i in this.state.clientInfo) {
			if (this.state.clientInfo[i] !== '') {
				this.setState({ disabled: false });
			} else {
				this.setState({ disabled: true });
			}
		}
	};

	handleSelect(eventKey, event) {
		this.setState(prevState => {
			return {
				otherDetails: {
					...prevState.otherDetails,
					sizeOfCurrentHome: House[eventKey],
				},
			};
		});
	}
	handleHearAboutSelect(eventKey, event) {
		this.setState(prevState => {
			return {
				otherDetails: { ...prevState.otherDetails, hearedAboutUs: HearAbout[eventKey] },
			};
		});
	}
	componentDidMount() {
		const obj = {};
		const prov = [];
		for (let i = 0; i < cities.length; i++) {
			obj[cities[i]['admin']] = cities.filter(city => city.admin === cities[i]['admin']);
		}
		// console.log(obj)
		for (let i in obj) {
			prov.push(i);
		}
		this.setState({
			allProvince: [...prov],
		});
	}

	itemsChangeHandler = async (value, cuft, category, name) => {
		await this.setState(prevState => {
			let updatedItems = prevState.listOfItems[category].items.map(item => {
				if (item.item === name) {
					return {
						...item,
						quantity: value,
						isSelected: true,
					};
				} else {
					return item;
				}
			});
			// console.log(updatedItems)
			return {
				listOfItems: { ...prevState.listOfItems, [category]: { ...prevState.listOfItems[category], items: updatedItems } },
			};
		});

		this.setState(prevState => {
			let updatedItems = prevState.listOfItems[category].items.map(item => {
				if (parseInt(item.quantity) > 0) {
					return {
						...item,
						isSelected: true,
					};
				} else {
					return item;
				}
			});
			return {
				listOfItems: { ...prevState.listOfItems, [category]: { ...prevState.listOfItems[category], items: updatedItems } },
			};
		});
		// console.log(this.state.listOfItems[category].items)
		let sum = 0;
		for (let i in this.state.listOfItems) {
			this.state.listOfItems[i].items.forEach(item => {
				if (parseInt(item.quantity) > 0 && !isNaN(item.CuFt) && !isNaN(item.quantity)) {
					sum += parseInt(item.CuFt) * parseInt(item.quantity);
				}
			});
		}
		// console.log(sum)
		this.setState({
			weight: sum * 7,
			volume: sum,
		});
	};

	movingFromStreetAddressHandler = async e => {
		this.setState({ movingFromDetails: { ...this.state.movingFromDetails, street: e.target.value } });
		let address = e.target.value;
		let url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&components=country:CA&key=AIzaSyAe-RvE9UpwF-SNkKvlpt4YpjOgDfaUCpQ`;
		try {
			let add = await ax(url);
			console.log(add);
			if (add.data.status === 'OK') {
				this.setState({
					streetFrom: true,
					streetFromMsg: '',
				});
			} else {
				this.setState({
					streetFrom: false,
					streetFromMsg: 'No address found',
				});
			}
		} catch (err) {}
	};
	movingToStreetAddressHandler = async e => {
		this.setState({ movingToDetails: { ...this.state.movingToDetails, street: e.target.value } });
		let address = e.target.value;
		let url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&components=country:CA&key=AIzaSyAe-RvE9UpwF-SNkKvlpt4YpjOgDfaUCpQ`;
		try {
			let add = await ax(url);
			if (add.data.status === 'OK') {
				this.setState({
					streetTo: true,
					streetToMsg: '',
				});
			} else {
				this.setState({
					streetTo: false,
					streetToMsg: 'No address found',
				});
			}
		} catch (err) {
			console.log(err);
		}
	};

	render() {
		const { classes } = this.props;
		const stepsContent = [
			<Fragment>
				<div className='container'>
					<div className='form-wrapper'>
						<div className='section-title text-left mb--50 mt--50'>
							<h3 className='title text-center'>Client Information</h3>
						</div>
						<form>
							<div class='row'>
								<div class='col-lg-2 col-md-2 col-xs-2'></div>
								<div class='col-lg-4 col-md-6 col-xs-6'>
									<label htmlFor='item01'>
										<input required type='text' name='firstName' id='item01' value={this.state.clientInfo.firstName} onChange={e => this.handleClientInfo(e.target.name, e.target.value)} placeholder='First Name' />
									</label>
								</div>
								<div class='col-lg-4 col-md-6 col-xs-6'>
									<label htmlFor='item02'>
										<input required type='text' name='lastName' id='item02' value={this.state.clientInfo.lastName} onChange={e => this.handleClientInfo(e.target.name, e.target.value)} placeholder='last Name' />
									</label>
								</div>
								<div class='col-lg-2 col-md-2 col-xs-2'></div>
							</div>
							<div class='row mb--0'>
								<div class='col-lg-2 col-md-2 col-xs-2'></div>
								<div class='col-lg-4 col-md-6 col-xs-6'>
									<label htmlFor='item03'>
										<input required type='text' name='phoneNo' id='item03' value={this.state.clientInfo.phoneNo} onChange={e => this.handleClientInfo(e.target.name, e.target.value)} placeholder='Phone Number' />
									</label>
								</div>
								<div class='col-lg-4 col-md-6 col-xs-6'>
									<label htmlFor='item04'>
										<input required type='text' name='email' id='item04' value={this.state.clientInfo.email} onChange={e => this.handleClientInfo(e.target.name, e.target.value)} placeholder='Your email' />
									</label>
								</div>
								<div class='col-lg-2 col-md-2 col-xs-2'></div>
							</div>
							<div class='row mb--20'>
								<div class='col-lg-2 col-md-2 col-xs-2'></div>
								<div class='col-lg-4 col-md-6 col-xs-6'>
									<label htmlFor='item03'>
										<input required type='date' name='prefferedMovingDate' id='item03' value={this.state.clientInfo.prefferedMovingDate} onChange={e => this.handleClientInfo(e.target.name, e.target.value)} placeholder='Preferred Moving Date' />
									</label>
								</div>
								<div class='col-lg-4 col-md-6 col-xs-6'>
									<label htmlFor='item04'>
										<input required type='time' name='prefferedMovingTime' id='item04' value={this.state.clientInfo.prefferedMovingTime} onChange={e => this.handleClientInfo(e.target.name, e.target.value)} placeholder='Preferred Moving Time' />
									</label>
								</div>
								<div class='col-lg-2 col-md-2 col-xs-2'></div>
							</div>
							{/* <div className='header-btn'>
							<button
								className='rn-btn'
								disabled={firstName === '' || lastName === '' || phoneNo === '' || email === '' || prefferedMovingDate === '' || prefferedMovingTime === ''}
								onClick={this.sendClientHanlder}
								type='button'
								href='/movedetails'
								style={{ height: '50px', width: '140px', paddingLeft: '40px', paddingTop: '5px' }}>
								<span style={{ fontSize: '17px' }}>Submit</span>
							</button>
						</div> */}
						</form>
					</div>
				</div>
			</Fragment>,
			<Fragment>
				<div className='contact-form--1'>
					<div className='container'>
						<div className='row row--35 align-items-start'>
							<div className='col-lg-6 order-2 order-lg-1'>
								<div className='section-title text-left mb--50 mt--50'>
									<h3 className='title'>Moving From</h3>
								</div>
								<div className='form-wrapper'>
									<form>
										<div class='row'>
											<div class='col-lg-6 col-md-6 col-xs-6'>
												<label htmlFor='item01'>
													<input type='text' name='street' id='item01' value={this.state.movingFromDetails.street} onChange={e => this.setState({ movingFromDetails: { ...this.state.movingFromDetails, street: e.target.value } })} placeholder='Street' />
												</label>
												{/* {this.state.streetFromMsg !== '' ? <label style={{ padding: '2vh', color: 'red' }}>{this.state.streetFromMsg}</label> : null} */}
											</div>
											<div class='col-lg-6 col-md-6 col-xs-6'>
												<label htmlFor='item02'>
													<input
														type='text'
														name='unitNumber'
														id='item02'
														value={this.state.movingFromDetails.unitNumber}
														onChange={e => {
															this.setState({ movingFromDetails: { ...this.state.movingFromDetails, unitNumber: e.target.value } });
														}}
														placeholder='Unit Number'
													/>
												</label>
											</div>
										</div>
										<div class='row mb--0'>
											<div class='col-lg-6 col-md-6 col-xs-6'>
												{/* <Typeahead
													id='moving-from-city'
													labelKey='city'
													onChange={e => {
														console.log(e);

														this.setState({ movingFromDetails: { ...this.state.movingFromDetails, city: e.length > 0 ? [e[0].city] : e, state: e.length > 0 ? [e[0].state] : e } });
													}}
													options={cities.map(city => {
														return { city: city.city, state: city.admin };
													})}
													placeholder='Choose From city...'
													selected={this.state.movingFromDetails.city}
												/> */}
												<label htmlFor='item02'>
													<input type='text' name='city' id='item02' value={this.state.movingFromDetails.city} onChange={e => this.setState({ movingFromDetails: { ...this.state.movingFromDetails, city: e.target.value } })} placeholder='City' />
												</label>
											</div>
											<div class='col-lg-6 col-md-6 col-xs-6'>
												{/* <label htmlFor='item04'>
													<Typeahead
														id='moving-from-state'
														labelKey='state'
														onChange={e => {
															this.setState({ movingFromDetails: { ...this.state.movingFromDetails, state: e.length > 0 ? [e[0]] : e } });
														}}
														options={this.state.allProvince}
														placeholder='Province'
														selected={this.state.movingFromDetails.state}
													/>
												</label> */}
												<label htmlFor='item03'>
													<input type='text' name='state' id='item03' value={this.state.movingFromDetails.state} onChange={e => this.setState({ movingFromDetails: { ...this.state.movingFromDetails, state: e.target.value } })} placeholder='Province/State' />
												</label>
											</div>
										</div>
										<div class='row mb--20'>
											<div class='col-lg-12 col-md-6 col-xs-6'>
												<label htmlFor='item05'>
													<input
														type='text'
														name='zip'
														id='item05'
														value={this.state.movingFromDetails.zip}
														onChange={e => {
															this.setState({ movingFromDetails: { ...this.state.movingFromDetails, zip: e.target.value } });
														}}
														placeholder='Postal code/Zip'
													/>
												</label>
											</div>
										</div>
										<div class='row mb--20'>
											<div class='col-lg-6 col-md-6 col-xs-6'>
												<FormControl component='fieldset'>
													<FormLabel component='legend'>Is there an Elevator?</FormLabel>
													<RadioGroup
														aria-label='gender'
														name='hasElevatorFrom'
														value={this.state.movingFromDetails.hasElevator}
														onChange={e => {
															this.setState({ movingFromDetails: { ...this.state.movingFromDetails, hasElevator: e.target.value } });
														}}>
														<div class='row' style={{ width: '230px' }}>
															<div class='col'>
																<FormControlLabel value='Yes' control={<Radio />} label='Yes' />
															</div>
															<div class='col'>
																<FormControlLabel value='No' control={<Radio />} label='No' />
															</div>
														</div>
													</RadioGroup>
												</FormControl>
											</div>
											<div class='col-lg-6 col-md-6 col-xs-6'>
												<label htmlFor='item06'>
													<input
														type='number'
														name='staires'
														id='item06'
														value={this.state.movingFromDetails.flightOfStairs}
														onChange={e => {
															this.setState({ movingFromDetails: { ...this.state.movingFromDetails, flightOfStairs: e.target.value } });
														}}
														placeholder='How many flights of stairs'
													/>
												</label>
											</div>
										</div>
									</form>
								</div>
							</div>
							<div className='col-lg-6 order-2 order-lg-1'>
								<div className='section-title text-left mb--50 mt--50'>
									<h3 className='title'>Moving To</h3>
								</div>
								<div className='form-wrapper'>
									<form>
										<div class='row'>
											<div class='col-lg-6 col-md-6 col-xs-6'>
												<label htmlFor='item08'>
													<input type='text' name='street' id='item08' value={this.state.movingToDetails.street} onChange={e => this.setState({ movingToDetails: { ...this.state.movingToDetails, street: e.target.value } })} placeholder='Street' />
												</label>
												{/* {this.state.streetToMsg !== '' ? <label style={{ padding: '2vh', color: 'red' }}>{this.state.streetToMsg}</label> : null} */}
											</div>
											<div class='col-lg-6 col-md-6 col-xs-6'>
												<label htmlFor='item09'>
													<input
														type='text'
														name='unitNumber'
														id='item09'
														value={this.state.movingToDetails.unitNumber}
														onChange={e => {
															this.setState({ movingToDetails: { ...this.state.movingToDetails, unitNumber: e.target.value } });
														}}
														placeholder='Unit Number'
													/>
												</label>
											</div>
										</div>
										<div class='row mb--0'>
											<div class='col-lg-6 col-md-6 col-xs-6'>
												{/* <Typeahead
													id='moving-from-city'
													labelKey='city'
													onChange={e => {
														console.log(e);

														this.setState({ movingToDetails: { ...this.state.movingToDetails, city: e.length > 0 ? [e[0].city] : e, state: e.length > 0 ? [e[0].state] : e } });
													}}
													options={cities.map(city => {
														return { city: city.city, state: city.admin };
													})}
													placeholder='Choose To city...'
													selected={this.state.movingToDetails.city}
												/> */}

												<label htmlFor='item09'>
													<input type='text' name='city' id='item09' value={this.state.movingToDetails.city} onChange={e => this.setState({ movingToDetails: { ...this.state.movingToDetails, city: e.target.value } })} placeholder='City' />
												</label>
											</div>
											<div class='col-lg-6 col-md-6 col-xs-6'>
												{/* <Typeahead
													id='moving-to-state'
													labelKey='state'
													onChange={e => {
														this.setState({ movingToDetails: { ...this.state.movingToDetails, state: e.length > 0 ? [e[0]] : e } });
													}}
													options={this.state.allProvince}
													placeholder='Province'
													selected={this.state.movingToDetails.state}
												/> */}

												<label htmlFor='item10'>
													<input type='text' name='state' id='item10' value={this.state.movingToDetails.state} onChange={e => this.setState({ movingToDetails: { ...this.state.movingToDetails, state: e.target.value } })} placeholder='Province/State' />
												</label>
											</div>
										</div>
										<div class='row mb--20'>
											<div class='col-lg-12 col-md-6 col-xs-6'>
												<label htmlFor='item012'>
													<input
														type='text'
														name='zip'
														id='item012'
														value={this.state.movingToDetails.zip}
														onChange={e => {
															this.setState({ movingToDetails: { ...this.state.movingToDetails, zip: e.target.value } });
														}}
														placeholder='Postal code/Zip'
													/>
												</label>
											</div>
										</div>
										<div class='row mb--20'>
											<div class='col-lg-6 col-md-6 col-xs-6'>
												<FormControl component='fieldset'>
													<FormLabel component='legend'>Is there an Elevator?</FormLabel>
													<RadioGroup aria-label='hasElevatorTo' name='hasElevatorTo' value={this.state.movingToDetails.hasElevator} onChange={e => this.setState({ movingToDetails: { ...this.state.movingToDetails, hasElevator: e.target.value } })}>
														<div class='row' style={{ width: '230px' }}>
															<div class='col'>
																<FormControlLabel value='Yes' control={<Radio />} label='Yes' />
															</div>
															<div class='col'>
																<FormControlLabel value='No' control={<Radio />} label='No' />
															</div>
														</div>
													</RadioGroup>
												</FormControl>
											</div>
											<div class='col-lg-6 col-md-6 col-xs-6'>
												<label htmlFor='item013'>
													<input
														type='number'
														name='stairs'
														id='item013'
														value={this.state.movingToDetails.flightOfStairs}
														onChange={e => {
															this.setState({ movingToDetails: { ...this.state.movingToDetails, flightOfStairs: e.target.value } });
														}}
														placeholder='How many flights of stairs'
													/>
												</label>
											</div>
										</div>

										{/* <label htmlFor="item04">
                                        <textarea
                                            type="text"
                                            id="item04"
                                            name="message"
                                            value={this.state.rnMessage}
                                            onChange={(e)=>{this.setState({rnMessage: e.target.value});}}
                                            placeholder="Your Message"
                                        />
                                    </label> */}
										{/* <div className="header-btn" >
                                        <button className="rn-btn" onClick={this.movingDetailsHandler} disabled={false} type="button" style={{height:'50px',width: '140px',paddingLeft:'40px',paddingTop:'5px'}}>
                                            <span style={{fontSize:'17px'}}>Submit</span>
                                        </button>
                                    </div> */}
									</form>
								</div>
							</div>
						</div>
						<div className='row row--35 align-items-start'></div>
					</div>
				</div>
			</Fragment>,
			<Fragment>
				<div className='contact-form--1'>
					<div className='container'>
						<div className='row row--35 align-items-start'>
							<div className='col-lg-12 order-2 order-lg-1'>
								<div className='section-title text-left mb--50 mt--50'>
									<h3 className='title text-center'>Other Details</h3>
								</div>
								<div className='form-wrapper'>
									<form onSubmit={this.otherDetailsHandler}>
										<div className='row'>
											<div className='col-lg-2 col-md-2 col-xs-6'></div>
											<div className='col-lg-4 col-md-6 col-xs-6'>
												<DropdownButton
													className='house-select-dropdown'
													onSelect={this.handleSelect.bind(this)}
													id='dropdown-item-button'
													variant='outlined'
													title={this.state.otherDetails.sizeOfCurrentHome}
													style={{ border: '2px solid rgba(0, 0, 0, 0.1)', height: '3.2rem', borderRadius: '5px', paddingTop: '.2rem' }}>
													{House.map((opt, i) => (
														<Dropdown.Item key={i} eventKey={i}>
															{opt}
														</Dropdown.Item>
													))}
												</DropdownButton>
											</div>
											<div class='col-lg-4 col-md-6 col-xs-6'>
												<FormControl component='fieldset'>
													<FormLabel component='legend'>Will you require packing services?</FormLabel>
													<RadioGroup aria-label='packingService' name='packingService' value={this.state.otherDetails.packingServiceRequired} onChange={e => this.setState({ otherDetails: { ...this.state.otherDetails, packingServiceRequired: e.target.value } })}>
														<div class='row' style={{ width: '230px' }}>
															<div class='col'>
																<FormControlLabel value='Yes' control={<Radio />} label='Yes' />
															</div>
															<div class='col'>
																<FormControlLabel value='No' control={<Radio />} label='No' />
															</div>
														</div>
													</RadioGroup>
												</FormControl>
											</div>
											<div className='col-lg-2 col-md-2 col-xs-6'></div>
										</div>
										<div class='row mb--20'>
											<div className='col-lg-2 col-md-2 col-xs-6'></div>
											<div class='col-lg-4 col-md-6 col-xs-6'>
												<DropdownButton
													id='dropdown-item-button'
													onSelect={this.handleHearAboutSelect.bind(this)}
													className='dropdown-toggle1'
													variant='outlined'
													title={this.state.otherDetails.hearedAboutUs}
													style={{ border: '2px solid rgba(0, 0, 0, 0.1)', height: '3.2rem', borderRadius: '5px', paddingTop: '.2rem' }}>
													{HearAbout.map((opt, i) => (
														<Dropdown.Item key={i} eventKey={i}>
															{opt}
														</Dropdown.Item>
													))}
												</DropdownButton>
												{this.state.otherDetails.hearedAboutUs === 'Other (Please specify in the text below)' ? (
													<label htmlFor='item04' style={{ marginTop: '2vh' }}>
														<input
															type='text'
															name='other'
															id='item04'
															value={this.state.other}
															onChange={e => {
																this.setState({ other: e.target.value });
															}}
															placeholder=''
														/>
													</label>
												) : null}
											</div>
											<div class='col-lg-4 col-md-6 col-xs-6'>
												<FormControl component='fieldset'>
													<FormLabel component='legend'>Do you require storage?</FormLabel>
													<RadioGroup aria-label='storage' name='storage' value={this.state.otherDetails.storageRequired} onChange={e => this.setState({ otherDetails: { ...this.state.otherDetails, storageRequired: e.target.value } })}>
														<div class='row' style={{ width: '230px' }}>
															<div class='col'>
																<FormControlLabel value='Yes' control={<Radio />} label='Yes' />
															</div>
															<div class='col'>
																<FormControlLabel value='No' control={<Radio />} label='No' />
															</div>
														</div>
													</RadioGroup>
												</FormControl>
												<label htmlFor='item04'>
													<input
														type='text'
														name='storageMonths'
														id='item04'
														value={this.state.otherDetails.storageMonths}
														onChange={e => {
															this.setState({ otherDetails: { ...this.state.otherDetails, storageMonths: e.target.value } });
														}}
														placeholder='If yes, for how long?'
													/>
												</label>
											</div>
											<div className='col-lg-2 col-md-2 col-xs-6'></div>
										</div>
										<div class='row mb--20'>
											<div className='col-lg-3 col-md-2 col-xs-6'></div>
											<div class='col-6'>
												<Form.Group controlId='exampleForm.ControlTextarea1'>
													<Form.Control as='textarea' value={this.state.otherDetails.note} onChange={e => this.setState({ otherDetails: { ...this.state.otherDetails, note: e.target.value } })} placeholder='Notes to Movers' />
												</Form.Group>
											</div>
											{/* <div className='col-lg-2 col-md-2 col-xs-6'></div> */}
										</div>
										{/* <label htmlFor="item04">
                                        <textarea
                                            type="text"
                                            id="item04"
                                            name="message"
                                            value={this.state.rnMessage}
                                            onChange={(e)=>{this.setState({rnMessage: e.target.value});}}
                                            placeholder="Your Message"
                                        />
                                    </label> */}
										{/* <button disabled={this.state.sizeOfCurrentHome === ''} className='rn-button-style--2 btn-solid' onClick={this.otherDetailsHandler}>
										Submit
									</button> */}
									</form>
								</div>
							</div>
							{/* <div className="col-lg-6 order-1 order-lg-2">
                            <div className="thumbnail mb_md--30 mb_sm--30">
                                <img src={`${this.props.contactImages}`} alt="trydo"/>
                            </div>
                        </div> */}
						</div>
					</div>
				</div>
			</Fragment>,
			<Fragment>
				<div className='container'>
					<div className='row row--35 align-items-start '>
						<div className={['col-lg-4 order-2 order-lg-1 mt-30', classes.CP].join(' ')}>
							<Table className='itemsTable' striped hover size='sm'>
								<thead>
									<tr>
										<th>BEDROOM</th>
										<th>Cu.Ft</th>
										<th>Qty</th>
									</tr>
								</thead>
								<tbody>
									{this.state.listOfItems.Bed_Rooms.items.map(item => (
										<tr>
											<td>{item.item}</td>
											<td>{item.CuFt}</td>
											<td>
												<input type='text' value={item.quantity} onChange={e => this.itemsChangeHandler(e.target.value, item.CuFt, 'Bed_Rooms', item.item)} />
											</td>
										</tr>
									))}
								</tbody>
							</Table>
							<Table className='itemsTable' striped hover size='sm'>
								<thead>
									<tr>
										<th>DININGROOM</th>
										<th>Cu.Ft</th>
										<th>Qty</th>
									</tr>
								</thead>
								<tbody>
									{this.state.listOfItems.Dining_Room.items.map(item => (
										<tr>
											<td>{item.item}</td>
											<td>{item.CuFt}</td>
											<td>
												<input type='text' value={item.quantity} onChange={e => this.itemsChangeHandler(e.target.value, item.CuFt, 'Dining_Room', item.item)} />
											</td>
										</tr>
									))}
								</tbody>
							</Table>
							<Table className='itemsTable' striped hover size='sm'>
								<thead>
									<tr>
										<th>MISCELLANEOUS</th>
										<th>Cu.Ft</th>
										<th>Qty</th>
									</tr>
								</thead>
								<tbody>
									{this.state.listOfItems.Miscellaneous.items.map(item => (
										<tr>
											<td>{item.item}</td>
											<td>{item.CuFt}</td>
											<td>
												<input type='text' value={item.quantity} onChange={e => this.itemsChangeHandler(e.target.value, item.CuFt, 'Miscellaneous', item.item)} />
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</div>

						<div className='col-lg-4 order-2 order-lg-1'>
							<Table className='itemsTable' striped hover size='sm'>
								<thead>
									<tr>
										<th>LIVINGROOM</th>
										<th>Cu.Ft</th>
										<th>Qty</th>
									</tr>
								</thead>
								<tbody>
									{this.state.listOfItems.Living_Room.items.map(item => (
										<tr>
											<td>{item.item}</td>
											<td>{item.CuFt}</td>
											<td>
												<input type='text' value={item.quantity} onChange={e => this.itemsChangeHandler(e.target.value, item.CuFt, 'Living_Room', item.item)} />
											</td>
										</tr>
									))}
								</tbody>
							</Table>
							<Table className='itemsTable' striped hover size='sm'>
								<thead>
									<tr>
										<th>Kitchen</th>
										<th>Cu.Ft</th>
										<th>Qty</th>
									</tr>
								</thead>
								<tbody>
									{this.state.listOfItems.Kitchen.items.map(item => (
										<tr>
											<td>{item.item}</td>
											<td>{item.CuFt}</td>
											<td>
												<input type='text' value={item.quantity} onChange={e => this.itemsChangeHandler(e.target.value, item.CuFt, 'Kitchen', item.item)} />
											</td>
										</tr>
									))}
								</tbody>
							</Table>
							<Table className='itemsTable' striped hover size='sm'>
								<thead>
									<tr>
										<th>Cartons</th>
										<th>Cu.Ft</th>
										<th>Qty</th>
									</tr>
								</thead>
								<tbody>
									{this.state.listOfItems.Cartons.items.map(item => (
										<tr>
											<td>{item.item}</td>
											<td>{item.CuFt}</td>
											<td>
												<input type='text' value={item.quantity} onChange={e => this.itemsChangeHandler(e.target.value, item.CuFt, 'Cartons', item.item)} />
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</div>

						<div className='col-lg-4 order-2 order-lg-1'>
							<Table className='itemsTable' striped hover size='sm'>
								<thead>
									<tr>
										<th>Nursery</th>
										<th>Cu.Ft</th>
										<th>Qty</th>
									</tr>
								</thead>
								<tbody>
									{this.state.listOfItems.Nursery.items.map(item => (
										<tr>
											<td>{item.item}</td>
											<td>{item.CuFt}</td>
											<td>
												<input type='text' value={item.quantity} onChange={e => this.itemsChangeHandler(e.target.value, item.CuFt, 'Nursery', item.item)} />
											</td>
										</tr>
									))}
								</tbody>
							</Table>
							<Table className='itemsTable' striped hover size='sm'>
								<thead>
									<tr>
										<th>Appliances</th>
										<th>Cu.Ft</th>
										<th>Qty</th>
									</tr>
								</thead>
								<tbody>
									{this.state.listOfItems.Appliances.items.map(item => (
										<tr>
											<td>{item.item}</td>
											<td>{item.CuFt}</td>
											<td>
												<input type='text' value={item.quantity} onChange={e => this.itemsChangeHandler(e.target.value, item.CuFt, 'Appliances', item.item)} />
											</td>
										</tr>
									))}
								</tbody>
							</Table>

							<Table className='itemsTable' striped hover size='sm'>
								<thead>
									<tr>
										<th>PORCH  OUTDOOR</th>
										<th>Cu.Ft</th>
										<th>Qty</th>
									</tr>
								</thead>
								<tbody>
									{this.state.listOfItems.Porch.items.map(item => (
										<tr>
											<td>{item.item}</td>
											<td>{item.CuFt}</td>
											<td>
												<input type='text' value={item.quantity} onChange={e => this.itemsChangeHandler(e.target.value, item.CuFt, 'Porch', item.item)} />
											</td>
										</tr>
									))}
								</tbody>
							</Table>
							<Table className='itemsTable' striped hover size='sm'>
								<thead>
									<tr>
										<th>
											CARTONS FOR AN AVERAGE <br />
											<small>( PLEASE ENTER 1 </small>)
										</th>
										<th>Cu.Ft</th>
										<th>Qty</th>
									</tr>
								</thead>
								<tbody>
									{this.state.listOfItems.CartoForAnAverage.items.map(item => (
										<tr>
											<td>{item.item}</td>
											<td>{item.CuFt}</td>
											<td>
												<input type='text' value={item.quantity} onChange={e => this.itemsChangeHandler(e.target.value, item.CuFt, 'CartoForAnAverage', item.item)} />
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</div>
					</div>
					<span id='WAV' style={{ padding: '0px 10px', fontSize: '20px', fontWeight: '700px' }}>
						Weight: {this.state.weight} lbs &nbsp;&nbsp; Volume: {this.state.volume} cu.ft.{' '}
					</span>
				</div>
			</Fragment>,
			<Fragment>
				<div className='rn-contact-page ptb--50 bg_color--1'>
					<div className='container'>
						<div className='row'>
							<h3>Based on your moving details the total estimate for your next move is:</h3>
							<div className='col-lg-9 col-md-6 col-sm-6 col-12'>
								<div className='row'>
									{/* Start Single Address  */}
									<div className='col-lg-4 col-md-6 col-sm-6 col-12'>
										<div className='rn-address'>
											<div className='icon'>
												<FiLock />
											</div>
											<div className='inner'>
												{this.state.finalCost === 0 ? (
													<div class='lds-ellipsis'>
														<div></div>
														<div></div>
														<div></div>
														<div></div>
													</div>
												) : (
													<p> $ {this.state.finalCost.toFixed(2)}</p>
												)}
											</div>
										</div>
										<h5 className='title'>Gross Price</h5>
									</div>
									{/* End Single Address  */}

									{/* Start Single Address  */}
									<div className='col-lg-4 col-md-6 col-sm-6 col-12 mt_mobile--50'>
										<div className='rn-address'>
											<div className='icon'>
												<GiTicket />
											</div>
											<div className='inner'>
												{this.state.depositeNowPrice === 0 ? (
													<div class='lds-ellipsis'>
														<div></div>
														<div></div>
														<div></div>
														<div></div>
													</div>
												) : (
													<p>$ {this.state.depositeNowPrice.toFixed(2)}</p>
												)}
											</div>
										</div>
										<h5 className='title'>Deposite Now</h5>
									</div>
									{/* End Single Address  */}

									{/* Start Single Address  */}
									<div className='col-lg-4 col-md-6 col-sm-6 col-12 mt_md--50 mt_sm--50'>
										<div className='rn-address'>
											<div className='icon'>
												<GiPriceTag />
											</div>
											<div className='inner'>
												<h5 className='title'>Add Coupon</h5>
											</div>
										</div>
									</div>
									{/* End Single Address  */}
								</div>
								<div className='row'>
									<div className='col-lg-1' style={{ paddingRight: '0' }}>
										<div className='check' style={{ fontSize: '5vh', textAlign: 'right' }}>
											<FiCheck />
										</div>
									</div>
									<div className='col-lg-11'>
										<p className='check-text' style={{ marginTop: '1.5vh' }}>
											Book Now! 25% Deposit is required to guarantee your spot
										</p>
									</div>

									<div className='col-lg-1' style={{ paddingRight: '0' }}>
										<div className='check' style={{ fontSize: '5vh', textAlign: 'right' }}>
											<FiCheck />
										</div>
									</div>
									<div className='col-lg-11'>
										<p className='check-text' style={{ marginTop: '1.5vh' }}>
											We will be calling you within 24 hours to confirm your booking
										</p>
									</div>

									<div className='col-lg-1' style={{ paddingRight: '0' }}>
										<div className='check' style={{ fontSize: '5vh', textAlign: 'right' }}>
											<FiCheck />
										</div>
									</div>
									<div className='col-lg-11'>
										<p className='check-text' style={{ marginTop: '1.5vh' }}>
											We may ask some specifics about your move.
										</p>
									</div>

									<div className='col-lg-1' style={{ paddingRight: '0' }}>
										<div className='check' style={{ fontSize: '5vh', textAlign: 'right' }}>
											<FiCheck />
										</div>
									</div>
									<div className='col-lg-11'>
										<p className='check-text' style={{ marginTop: '1.5vh' }}>
											3 days prior to moving date, we will give you a call to make sure everything’s ok.
										</p>
									</div>

									{/* <div className='col-lg-1' style={{ paddingRight: '0', marginBottom: '3vh' }}>
										<div className='check' style={{ fontSize: '5vh', textAlign: 'right' }}>
											
										</div>
									</div>
									<div className='col-lg-11'>
										<p className='check-text' style={{ marginTop: '1.5vh' }}>
											The moving company will contact you for final details
										</p>
									</div> */}
								</div>
							</div>
							<div className='col-lg-3'>
								<div className='row'>
									{/* <div className='col-lg-12 mb-3'>
										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<KeyboardDatePicker
												margin='normal'
												id='date-picker-dialog'
												label='Date picker'
												format='MM/dd/yyyy'
												value={this.state.selectedDate}
												onChange={this.handleDateChange}
												KeyboardButtonProps={{
													'aria-label': 'change date',
												}}
											/>
										</MuiPickersUtilsProvider>
									</div> */}
									<div className='col-lg-12'>
										<div className='bookNow text-center pt--30'>
											<button className='rn-btn' onClick={this.handleNext} style={{ height: '50px', width: '30vh', paddingLeft: '25px', paddingTop: '5px' }}>
												<span style={{ fontSize: '17px' }}>BOOK NOW</span>
											</button>
											<p>Get an EXTRA 10% Off</p>
										</div>
									</div>
									<div className='col-lg-12 mt-3'></div>
									<div className='col-lg-12'>
										<div className='SaveNow text-center'>
											<a className='rn-btn' href='/movedetails' style={{ height: '50px', width: '40vh', paddingLeft: '10px', paddingRight: '10px', paddingTop: '5px' }}>
												<span style={{ fontSize: '17px' }}>SAVE AND BOOK LATER</span>
											</a>
											<p>Save your info and book later</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Fragment>,
			<Fragment>
				<div className='container'>
					<div className='row row--35 align-items-start'>
						<div className='col-lg-12 order-2 order-lg-1'>
							<Tabs defaultActiveKey='home' id='uncontrolled-tab-example'>
								<Tab eventKey='home' title='Paypal'>
									<div className='contact-form--1'>
										<div className='container'>
											<div className='row row--35 align-items-start'>
												<div className='col-lg-12 order-2 order-lg-1'>
													<div className='section-title text-left mb--50 mt--50'>
														<h3 className='title'>Payment with Paypal</h3>
													</div>
													<div className='form-wrapper'>
														<form>
															<div class='button text-center' style={{ width: '390px' }}>
																<PayPalButton
																	blue
																	amount={this.state.costWthTenPercentOff}
																	// shippingPreference="NO_SHIPPING" // default is "GET_FROM_FILE"
																	onSuccess={(details, data) => {
																		alert('Transaction completed by ' + details.payer.name.given_name);
																		axios
																			.post('/paymentRecords', { amount: this.state.costWthTenPercentOff, clientId: this.tate.clientId })
																			.then(res => {
																				console.log(res);
																			})
																			.catch(err => {
																				console.log(err);
																			});

																		// OPTIONAL: Call your server to save the transaction
																		return fetch('/paypal-transaction-complete', {
																			method: 'post',
																			body: JSON.stringify({
																				orderID: data.orderID,
																			}),
																		});
																	}}
																/>
															</div>
															{/* <div class='row'>
																<div class='col-lg-6 col-md-6 col-xs-6'>
																	<label htmlFor='item05'>
																		<input
																			type='text'
																			name='card'
																			id='item07'
																			value={this.state.paymentInfo.card}
																			onChange={e => {
																				this.setState(prevState => {
																					return {
																						...prevState.paymentInfo,
																						card: e.target.value,
																					};
																				});
																			}}
																			placeholder='Card #'
																		/>
																	</label>
																</div>
															</div>

															<div class='row mb--20'>
																<div class='col-lg-3 col-md-6 col-xs-6'>
																	<label htmlFor='item05'>
																		<input
																			type='date'
																			name='expiryDate'
																			id='item07'
																			value={this.state.paymentInfo.expiryDate}
																			onChange={e => {
																				this.setState(prevState => {
																					return {
																						...prevState.paymentInfo,
																						expiryDate: e.target.value,
																					};
																				});
																			}}
																			placeholder='Expiry Date'
																		/>
																	</label>
																</div>
																<div class='col-lg-3 col-md-6 col-xs-6'>
																	<label htmlFor='item05'>
																		<input
																			type='text'
																			name='cvv'
																			id='item07'
																			value={this.state.paymentInfo.cvv}
																			onChange={e => {
																				this.setState(prevState => {
																					return {
																						...prevState.paymentInfo,
																						CVV: e.target.value,
																					};
																				});
																			}}
																			placeholder='CVV'
																		/>
																	</label>
																</div>
															</div>

															<div class='row mb--10'>
																<div class='col-lg-6 col-md-6 col-xs-6'>
																	<label htmlFor='item01'>
																		<input
																			type='text'
																			name='address1'
																			id='item01'
																			value={this.state.paymentInfo.address1}
																			onChange={e => {
																				this.setState(prevState => {
																					return {
																						...prevState.paymentInfo,
																						address1: e.target.value,
																					};
																				});
																			}}
																			placeholder='Address 1'
																		/>
																	</label>
																</div>
															</div>
															<div class='row mb--10'>
																<div class='col-lg-6 col-md-6 col-xs-6'>
																	<label htmlFor='item02'>
																		<input
																			type='text'
																			name='address2'
																			id='item02'
																			value={this.state.paymentInfo.address2}
																			onChange={e => {
																				this.setState(prevState => {
																					return {
																						...prevState.paymentInfo,
																						address2: e.target.value,
																					};
																				});
																			}}
																			placeholder='Address 2'
																		/>
																	</label>
																</div>
															</div>

															<div class='row mb--10'>
																<div class='col-lg-6 col-md-6 col-xs-6'>
																	<label htmlFor='item03'>
																		<input
																			type='text'
																			name='city'
																			id='item03'
																			value={this.state.paymentInfo.city}
																			onChange={e => {
																				this.setState(prevState => {
																					return {
																						...prevState.paymentInfo,
																						city: e.target.value,
																					};
																				});
																			}}
																			placeholder='City'
																		/>
																	</label>
																</div>
															</div>
															<div class='row mb--10'>
																<div class='col-lg-6 col-md-6 col-xs-6'>
																	<label htmlFor='item04'>
																		<input
																			type='text'
																			name='zip'
																			id='item04'
																			value={this.state.paymentInfo.zip}
																			onChange={e => {
																				this.setState(prevState => {
																					return {
																						...prevState.paymentInfo,
																						zip: e.target.value,
																					};
																				});
																			}}
																			placeholder='Zip/Postal code'
																		/>
																	</label>
																</div>
															</div>

															<div class='row mb--10'>
																<div class='col-lg-3 col-md-6 col-xs-6'>
																	<label htmlFor='item06'>
																		<input
																			type='text'
																			name='country'
																			id='item05'
																			value={this.state.paymentInfo.country}
																			onChange={e => {
																				this.setState(prevState => {
																					return {
																						...prevState.paymentInfo,
																						country: e.target.value,
																					};
																				});
																			}}
																			placeholder='Country'
																		/>
																	</label>
																</div>
																<div class='col-lg-3 col-md-6 col-xs-6'>
																	<label htmlFor='item05'>
																		<input
																			type='text'
																			name='state'
																			id='item07'
																			value={this.state.paymentInfo.state}
																			onChange={e => {
																				this.setState(prevState => {
																					return {
																						...prevState.paymentInfo,
																						state: e.target.value,
																					};
																				});
																			}}
																			placeholder='State'
																		/>
																	</label>
																</div>
															</div>*/}
														</form>
													</div>
												</div>
											</div>
										</div>
									</div>
								</Tab>
								<Tab eventKey='profile' title='Credit Card'>
									<div className='contact-form--1'>
										<div className='container'>
											<div className='row row--35 align-items-start'>
												<div className='col-lg-12 order-2 order-lg-1'>
													<div className='section-title text-left mt--50 mb--50'>
														<h3 className='title'>Credit Card</h3>
													</div>
												</div>
												<div className='col-lg-12 order-2 order-lg-1'>
													<div className='App'>
														<p className='App-intro'>
															<Checkout name={'Your Company Name'} description={'Item that you sold'} amount={this.state.costWthTenPercentOff} />
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</Tab>
							</Tabs>
						</div>
					</div>
				</div>
			</Fragment>,
		];

		let activeStep;

		if (this.state.activeStep === 0) {
			activeStep = (
				<Button
					disabled={this.state.clientInfo.firstName === '' || this.state.clientInfo.lastName === '' || this.state.clientInfo.email === '' || this.state.clientInfo.phoneNo === '' || this.state.clientInfo.prefferedMovingDate === ''}
					className={['rn-btn', classes.btnBack].join(' ')}
					variant='contained'
					color='primary'
					onClick={this.handleNext}>
					{this.state.activeStep === this.state.steps.length - 1 ? 'Finish' : 'Next'}
				</Button>
			);
		} else if (this.state.activeStep === 1) {
			activeStep = (
				<Button
					disabled={
						this.state.cityFrom === false ||
						this.state.cityTo === false ||
						this.state.movingToDetails.street === '' ||
						this.state.movingFromDetails.street === '' ||
						this.state.movingFromDetails.city === '' ||
						this.state.movingToDetails.city === '' ||
						this.state.movingToDetails.state === '' ||
						this.state.movingFromDetails.state === ''
					}
					className={['rn-btn', classes.btnBack].join(' ')}
					variant='contained'
					color='primary'
					onClick={this.handleNext}>
					{this.state.activeStep === this.state.steps.length - 1 ? 'Finish' : 'Next'}
				</Button>
			);
		} else if (this.state.activeStep === 2) {
			activeStep = (
				<Button disabled={this.state.otherDetails.sizeOfCurrentHome === 'Size of your current home'} className={['rn-btn', classes.btnBack].join(' ')} variant='contained' color='primary' onClick={this.handleNext}>
					{this.state.activeStep === this.state.steps.length - 1 ? 'Finish' : 'Next'}
				</Button>
			);
		} else if (this.state.activeStep === 3) {
			activeStep = (
				<Button disabled={this.state.weight === 0} className={['rn-btn', classes.btnBack].join(' ')} variant='contained' color='primary' onClick={this.handleNext}>
					{this.state.activeStep === this.state.steps.length - 1 ? 'Finish' : 'Next'}
				</Button>
			);
		} else if (this.state.activeStep === 4) {
			activeStep = (
				<Button disabled={this.state.finalCost === 0} className={['rn-btn', classes.btnBack].join(' ')} variant='contained' color='primary' onClick={this.handleNext}>
					{this.state.activeStep === this.state.steps.length - 1 ? 'Finish' : 'Next'}
				</Button>
			);
		} else if (this.state.activeStep === 5) {
			activeStep = (
				<Button className={['rn-btn', classes.btnBack].join(' ')} variant='contained' color='primary' onClick={this.handleNext}>
					{this.state.activeStep === this.state.steps.length - 1 ? 'Finish' : 'Next'}
				</Button>
			);
		}
		return (
			<Fragment>
				<Modal
					aria-labelledby='transition-modal-title'
					aria-describedby='transition-modal-description'
					className={classes.modal}
					open={this.state.OpenModal}
					onClose={this.handleClose}
					closeAfterTransition
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500,
					}}>
					<Fade in={this.state.OpenModal}>
						<div className={classes.paper1}>
							<div className='text-center'>
								<h4 style={{ fontSize: '25px', marginTop: '2rem' }} id='transition-modal-title'>
									{this.state.errorMsg}
								</h4>
								<Button
									onClick={() => {
										this.handleClose();
									}}
									variant='primary'
									style={{ width: '13rem', background: '#de2828', marginTop: '2vh' , color:'#fff' }}>
									OK
								</Button>
							</div>
						</div>
					</Fade>
				</Modal>

				<div className='contact-form--1'>
					<div className='container'>
						<div className='row row--35 align-items-start'>
							<div className='col-lg-12 order-2 order-lg-1'>
								<Stepper activeStep={this.state.activeStep} alternativeLabel>
									{this.state.steps.map(label => (
										<Step key={label}>
											<StepLabel>{label}</StepLabel>
										</Step>
									))}
								</Stepper>
								<div>
									{this.state.activeStep === this.state.steps.length ? (
										<div>
											<Typography className={classes.instructions}>All steps completed</Typography>
											<Button onClick={this.handleReset}>Reset</Button>
										</div>
									) : (
										<div>
											<div className={classes.instructions}>{stepsContent[this.state.activeStep]}</div>
											<div class='text-center'>
												<Button disabled={this.state.activeStep === 0} onClick={this.handleBack} className={classes.backButton}>
													Back
												</Button>
												{activeStep}
											</div>
										</div>
									)}
								</div>
								{/* <div className='section-title text-left mb--50'>
								<h2 className='title'>Client Information</h2>
							</div>
							 */}
							</div>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}
export default withRouter(withStyles(styles)(ContactThree));
